import { SegmentWindow } from './types';
import { User } from '~/typings/user';
import { get } from '~/utils/object';

const formatUser = (user: User = {} as User, additionalProps = {}) => {
  const email = get(user, 'email', '');
  return {
    email,
    id: user.key,
    key: user.key,
    username: get(user, 'username', email),
    dateCreated: user.dateCreated,
    dateModified: user.dateModified,
    department: get(user, 'department', ''),
    lastLogin: user.lastAuthenticatedAt,
    name: get(user, 'name', email),
    company: get(user, 'company', ''),
    jobTitle: get(user, 'jobTitle', ''),
    ...additionalProps,
  };
};

function formatGroup(orgAccount = {}) {
  return {
    // fallback to the first domain if the org description is not available,
    // or the orgKey in the worst case scenario for consistency
    orgName:
      get(orgAccount, 'description', '') ||
      get(orgAccount, 'domains', [])[0] ||
      get(orgAccount, 'key', ''),
    orgId: get(orgAccount, 'key', ''),
    orgKey: get(orgAccount, 'key', ''),
    orgDomains: get(orgAccount, 'domains', []).join(', '),
  };
}

const identify = (user: User, extraProps: Record<string, any> = {}) => {
  const win: SegmentWindow = window;
  if (win && win.analytics) {
    const { orgAccount } = user;
    const groupProps = formatGroup(orgAccount);
    // Identify the user
    win.analytics.identify(
      user.key,
      formatUser(user, { ...groupProps, ...extraProps }),
    );
    // Identify the Org
    if (orgAccount?.key) {
      win.analytics.group(orgAccount.key, { ...groupProps });
    }
  }
};

export default identify;
